import { render, staticRenderFns } from "./TaskToggleStatus.vue?vue&type=template&id=65ef5366&scoped=true&"
import script from "./TaskToggleStatus.vue?vue&type=script&lang=js&"
export * from "./TaskToggleStatus.vue?vue&type=script&lang=js&"
import style0 from "./TaskToggleStatus.vue?vue&type=style&index=0&id=65ef5366&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ef5366",
  null
  
)

export default component.exports